import { SITE_CONFIG } from '../config/site-config';
import { escapeHtml } from '../lib/html';
import { EXTERNAL_LINK_ATTRS, isConfigured, salesMailto } from '../lib/links';
import { ARROW_ICON, icon } from './icons';

/** Step 2 of the /demo flow, shown only after the lead was captured. */
export function scheduleStep(first: string, optionalCal: boolean): string {
  const cal = isConfigured(SITE_CONFIG.SALES_CALENDAR_URL);
  const embed = isConfigured(SITE_CONFIG.SALES_CALENDAR_EMBED_URL);
  return `
  <div class="sched" tabindex="-1" aria-live="polite">
    <ol class="progress" aria-label="Progress"><li class="done"><span>${icon('check')}</span>Information</li><li class="on" aria-current="step"><span>2</span>Schedule</li></ol>
    <p class="step-lab">Step 2 of 2</p>
    <h2 class="h-cap">${optionalCal ? `Thanks, ${escapeHtml(first)}.` : 'Choose a time that works for you.'}</h2>
    <p class="muted">${optionalCal ? "We've received your information. Our team can follow up with you, or you can choose an available time now." : `Thanks, ${escapeHtml(first)}. We've received your information. Now choose an available time below to meet with the ReTax360 team.`}</p>
    ${
      cal
        ? `<div class="ctas sched-ctas">
      <a class="btn btn-primary btn-lg" href="${SITE_CONFIG.SALES_CALENDAR_URL}" ${EXTERNAL_LINK_ATTRS} data-schedule>${optionalCal ? 'Choose an Available Time' : 'View Available Times'} ${ARROW_ICON}</a>
      ${optionalCal ? '<button class="btn btn-ghost" type="button" data-wait>I\'ll wait for your team to reach out.</button>' : ''}
    </div>
    ${embed && !optionalCal ? `<iframe class="cal" src="${SITE_CONFIG.SALES_CALENDAR_EMBED_URL}" title="Choose a time with ReTax360" loading="lazy" width="100%"></iframe><p class="fine">Trouble loading the calendar? Use <b>View Available Times</b> above to open it in a new tab.</p>` : ''}`
        : `<p class="muted">Our team will reach out to schedule a time. Prefer email? <a class="ul" href="${salesMailto()}">${SITE_CONFIG.SALES_EMAIL}</a></p>`
    }
  </div>`;
}
